module.exports = __webpack_public_path__ + "img/EXTRA_PROFILE_VIEWS.33512b76.svg";